module.exports = __webpack_public_path__ + "img/Hero@3x.f709a1c6.png";